import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faShopify,
} from '@fortawesome/free-brands-svg-icons';
import { Button } from '@material-ui/core';

import useIntegration from '@root/resources/integrations/useIntegration';
import SimpleTooltip from '@root/components/tooltips/SimpleTooltip';
import ExternalSourceText from '@root/components/integrations/ExternalSource/ExternalSourceText';
import ExternalSourcesContext from '@root/resources/externalSources/externalSources.context';

import useStyles from './ShopifyConnected.styles';

const ShopifyConnected = ({ setSelectingProduct }) => {
  const classes = useStyles();
  const { data, isLoading } = useIntegration('shopify');

  if (isLoading || !data) {
    return null;
  }
  const { currentExternalSource } = ExternalSourcesContext.useExternalSource();

  const { showExternalSourceTooltip } = currentExternalSource.toggles;

  const tooltipContent = showExternalSourceTooltip
    ? <ExternalSourceText />
    : (
      <div>
        <div className={classes.text}>
          Connected Shopify Store:
          {' '}
          <div className={classes.storeName}>
            {data.data.subdomain}
          </div>
        </div>
        <br />
        <Button
          variant="text"
          onClick={setSelectingProduct}
          className={classes.button}
        >
          Generate Shopify Product Descriptions
        </Button>
      </div>
    );

  return (
    <SimpleTooltip
      interactive
      content={tooltipContent}
      placement="bottom-start"
    >
      <span>
        <FontAwesomeIcon
          className={classes.root}
          icon={faShopify}
        />
      </span>
    </SimpleTooltip>

  );
};

export default ShopifyConnected;
